/* sm-footer — mobile (<=768px) link-column accordions, one open at a time, "+" rotates to "x".
   Desktop keeps the columns static. Mirrors Manukora's new-footer.js. */
(function () {
  var MOBILE = 768;

  function init(footer) {
    var cols = Array.prototype.slice.call(footer.querySelectorAll('.sm-footer__col'));
    if (!cols.length) return;
    var bound = false;

    function isMobile() {
      return window.innerWidth <= MOBILE;
    }
    function panelOf(col) {
      return col.querySelector('.sm-footer__col-list');
    }
    function triggerOf(col) {
      return col.querySelector('.sm-footer__col-title');
    }
    function closePanel(col) {
      var p = panelOf(col), t = triggerOf(col);
      if (!p) return;
      p.classList.remove('is-open');
      p.style.maxHeight = '0px';
      t.classList.remove('is-open');
      t.setAttribute('aria-expanded', 'false');
    }
    function openPanel(col) {
      var p = panelOf(col), t = triggerOf(col);
      if (!p) return;
      p.style.maxHeight = 'none';
      var full = p.scrollHeight;
      p.style.maxHeight = '0px';
      void p.offsetHeight;
      p.classList.add('is-open');
      p.style.maxHeight = full + 'px';
      t.classList.add('is-open');
      t.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        if (p.classList.contains('is-open')) p.style.maxHeight = 'none';
      }, 450);
    }
    function onTrigger(e) {
      if (!isMobile()) return;
      e.preventDefault();
      var col = e.currentTarget.closest('.sm-footer__col');
      var wasOpen = panelOf(col).classList.contains('is-open');
      cols.forEach(function (c) {
        if (c !== col) closePanel(c);
      });
      wasOpen ? closePanel(col) : openPanel(col);
    }
    function setup() {
      if (isMobile()) {
        cols.forEach(closePanel);
        if (!bound) {
          cols.forEach(function (c) {
            var t = triggerOf(c);
            t.addEventListener('click', onTrigger);
            t.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onTrigger({ currentTarget: t, preventDefault: function () {} });
              }
            });
          });
          bound = true;
        }
      } else {
        cols.forEach(function (c) {
          var p = panelOf(c), t = triggerOf(c);
          p.classList.remove('is-open');
          p.style.maxHeight = '';
          t.classList.remove('is-open');
          t.removeAttribute('aria-expanded');
        });
      }
    }
    setup();
    var wasMobile = isMobile();
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var now = isMobile();
        if (now !== wasMobile) {
          wasMobile = now;
          setup();
        } else if (now) {
          cols.forEach(function (c) {
            var p = panelOf(c);
            if (p.classList.contains('is-open')) {
              p.style.maxHeight = 'none';
              p.style.maxHeight = p.scrollHeight + 'px';
            }
          });
        }
      }, 100);
    });
  }

  function boot() {
    document.querySelectorAll('[data-sm-footer]').forEach(function (f) {
      if (f.dataset.smInit) return;
      f.dataset.smInit = '1';
      init(f);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
